import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { serviceForMultipleSegments, usePassengerState } from '../../../hooks';
import { getBaggageCalculatedRestrictionCount } from '../../../store/selector';
import { getMinBaggageCount, updateSelectedItems } from '../../../utils';
import BaggageCounter from '../../../../BaggageCounter';
import { Tooltip } from '../../../../../BaseComponents';
const PassengerBaggageCounter = ({ className, passenger, baggages, onChange, isIncreaseDisabled: increaseDisabled, segmentIds, segmentId }) => {
    const { t } = useTranslation('IncludedBaggage');
    const theme = useTheme('UpgradeBaggageDialog').BaggagePassenger;
    const [tooltipOpen, setTooltipOpen] = React.useState(false);
    const baggage = baggages[0];
    const passengerId = passenger.id;
    const { items, selectedItems, selectedCount, confirmedCount } = usePassengerState(passenger, baggages, segmentIds, segmentId);
    const { maxCount, selectedCount: baggageSelectedCount, isExistRestriction } = useSelector(getBaggageCalculatedRestrictionCount({ baggage, passengerId, segmentId, segmentIds }));
    const isConfirmed = React.useMemo(() => selectedCount === confirmedCount, [selectedCount, confirmedCount]);
    const isIncreaseDisabled = React.useMemo(() => {
        const selectedBaggageCount = isExistRestriction ? baggageSelectedCount : selectedCount;
        return maxCount <= selectedBaggageCount || increaseDisabled || isConfirmed;
    }, [maxCount, isExistRestriction, baggageSelectedCount, selectedCount, increaseDisabled, isConfirmed]);
    const minCount = React.useMemo(() => getMinBaggageCount(passenger, baggages, segmentId), [passenger]);
    const multipleSegments = React.useMemo(() => serviceForMultipleSegments(baggages[0]), [baggages]);
    const onChangeHandler = (count) => {
        const newItems = updateSelectedItems(selectedCount, count, items, selectedItems);
        if (newItems) {
            onChange(newItems);
        }
        if (multipleSegments) {
            setTooltipOpen(true);
            setTimeout(() => setTooltipOpen === null || setTooltipOpen === void 0 ? void 0 : setTooltipOpen(false), 700);
        }
    };
    return (React.createElement("div", { className: cn(className, theme.counter_wrapper) },
        React.createElement(Tooltip, { title: t('Added for all flights'), disableHoverListener: !multipleSegments, disableTouchListener: !multipleSegments, open: tooltipOpen },
            React.createElement("div", null,
                React.createElement(BaggageCounter, { max: maxCount, min: minCount, value: selectedCount, isIncreaseDisabled: isIncreaseDisabled, isDecreaseDisabled: isConfirmed, onChange: onChangeHandler })))));
};
export default PassengerBaggageCounter;
